// extracted by mini-css-extract-plugin
export default {"FadeIn":"Fader_FadeIn__wHPhm","fadeIn":"Fader_fadeIn__0zUvU","FadeOut":"Fader_FadeOut__FD0wk","fadeOut":"Fader_fadeOut__gW7+j"};